import { useEffect } from 'react'
import { useAnalyticsView } from '@/features/amplitude'
import { useAppDispatch } from '@/utils/typeHelpers'
import { useReselector } from '@/utils/sharedHooks'
import { getIsFetching } from '@/reducers/fetch'
import { fetchTransactionCategoriesIfNeeded } from '@/features/reports/reports.slice'

import { ExpensesPieChartRow } from './ExpensesPieChartRow'
import { ExpensesTransactionTable } from './ExpensesTransactionTable'
import { Card, CardColors, Text } from '@/ui'

import {
  fetchUserTransactions,
  USER_TRANSACTION_KEY,
} from '@/features/transactions/transactions.slice'
import { PageHeader } from '@/components/PageHeader'
import { TypographyStyles } from '@/styles'

export const ExpensesPanel = () => {
  const dispatch = useAppDispatch()
  const isLoading = useReselector(getIsFetching, USER_TRANSACTION_KEY)

  const pageView = useAnalyticsView()

  useEffect(() => {
    pageView('expense breakdown')
  }, [pageView])

  useEffect(() => {
    dispatch(fetchTransactionCategoriesIfNeeded())
    dispatch(fetchUserTransactions())
  }, [dispatch])

  const renderEmptyState = () => {
    return (
      <div className="flex flex-col gap-2">
        <Text variant={TypographyStyles.H3} className="mb-4">
          Your Expenses Breakdown is being built!
        </Text>
        <Text variant={TypographyStyles.BODY_SM}>
          This breakdown will give you an insight into where your spending lies.
        </Text>
        <Text variant={TypographyStyles.BODY_SM}>
          Once your bookkeeper finishes categorizing your expenses, your
          breakdown will be ready. We will notify you when it is ready to view!
        </Text>
      </div>
    )
  }

  const renderReports = () => {
    return (
      <div className="flex flex-col gap-4">
        <ExpensesPieChartRow />

        <Text variant={TypographyStyles.H3}>Latest Categorized Expenses</Text>
        <ExpensesTransactionTable />
      </div>
    )
  }

  const renderPanel = () => {
    if (isLoading) {
      return renderEmptyState()
    } else {
      return renderReports()
    }
  }

  return (
    <>
      <PageHeader header="Your Expenses Breakdown" />
      <Card color={CardColors.LEVEL_1}>{renderPanel()}</Card>
    </>
  )
}
